<template>
  <footer class="footer">
    
    <div class="footer-content">
      

      <!--
      <div class="footer-section icon-block">
        <CardWithIcon
          icon="idea"
          color="orange"
          text="**Turn** to the experts"
          ></CardWithIcon>
      </div>
      -->
      <div class="footer-section">
        <h3>Get in touch</h3>
        <p>Email us at
          <a :href="'mailto:' + siteInfo.contactEmail">{{ siteInfo.contactEmail }}</a>
          to start a conversation about how turnKey can help your CRC.
          
        </p>
        
      </div>
      <!--
      <div class="footer-section">
        <h3>Follow Us</h3>
        <div class="social-links">
          <a href="#" target="_blank" rel="noopener">LinkedIn</a>
          <a href="#" target="_blank" rel="noopener">Twitter</a>
        </div>
      </div>
      -->
    </div>
    <div class="footer-bottom">
      <!-- Add in current year later {{ new Date().getFullYear() }}-->
      <p>Copyright &copy; {{ siteInfo.copyright.holder }} {{ siteInfo.copyright.startDate }}. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
import siteInfo from '@/content/site-info.yml';

export default {
  data() {
    return { siteInfo };
  }
}
</script>


<style lang="scss">
@use '@/assets/scss/main.scss';
@use '@/assets/scss/abstracts/variables' as *;
@use '@/assets/scss/abstracts/mixins' as *;




.footer {
  //background: $blue-dark;
  padding-top: $spacing-xl;
  margin-top: auto;
  //color: $color-background;
  border-top:4px solid $blue-dark;
  text-wrap: balance;
  .footer-content {
    max-width: $container-width;
    margin: 0 auto;
    /**
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-template-columns: 1fr 2fr 1fr;
    gap: $grid-gap;
    */
  }


  .footer-section {
    text-align: center;
    width: 100%;
    padding: 0 $spacing-md;
    h3 {
      color: $orange;
      margin-bottom: $spacing-md;
      font-size: 1.2rem;
      @include proxima-bold;
    }

    p {
      //color: rgba($color-background, 0.8);
      color: $blue-dark;
      margin-bottom: $spacing-sm;
      @include proxima-regular;
      
    }
  }

  .social-links {
    display: flex;
    gap: $spacing-md;
    
  }
  a {
    color: $blue-bright;
    text-decoration: underline;
    @include proxima-regular;
    
    &:hover {
      color: $blue-dark;
    }
    &:active {
      color: $orange;
    }
  }

  .footer-bottom {
    margin-top: $spacing-lg;
    padding: $spacing-md;
    border-top: 1px solid rgba($color-background, 0.1);
    text-align: center;
    background-color: $blue-dark;
    color: $color-white;
    @include proxima-regular;
  }
} 

</style> 